import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface Issue {
  id: string;
  title: string;
  titleHe: string;
  date: string;
  dateHe: string;
  coverColor: string;
  coverImage?: string;
  pdfUrl?: string;
}
const issues: Issue[] = [{
  id: '1',
  title: 'May 2026',
  titleHe: 'מאי 2026',
  date: 'May 2026',
  dateHe: 'מאי 2026',
  coverColor: '#D5E8C4',
  coverImage: 'https://drive.google.com/thumbnail?id=1YtmUrtSzpWvx2fiDfE2uOvpkMKWM4-C4&sz=w1000',
  pdfUrl: 'https://drive.google.com/file/d/1YtmUrtSzpWvx2fiDfE2uOvpkMKWM4-C4/view?usp=sharing'
}, {
  id: '2',
  title: 'July 2026',
  titleHe: 'יולי 2026',
  date: 'Jul 2026',
  dateHe: 'יולי 2026',
  coverColor: '#C4D5E8',
  coverImage: 'https://drive.google.com/thumbnail?id=1TmhAHxLZPAwtN1eTtzE8xgVJ1DMatTVi&sz=w1000',
  pdfUrl: 'https://drive.google.com/file/d/1TmhAHxLZPAwtN1eTtzE8xgVJ1DMatTVi/view?usp=sharing'
}, {
  id: '3',
  title: 'September 2026',
  titleHe: 'ספטמבר 2026',
  date: 'Sep 2026',
  dateHe: 'ספט׳ 2026',
  coverColor: '#E8D5C4',
  pdfUrl: ''
}];
export function IssuesPage() {
  const {
    t,
    language
  } = useLanguage();
  const isHebrew = language === 'he';
  return <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12" dir={isHebrew ? 'rtl' : 'ltr'} data-id="element-113" data-mp="245zxbzoilh5g">
      <motion.h1 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-3xl md:text-5xl font-bold mb-8 md:mb-12 text-center text-[#2A4B7C]" data-id="element-114" data-mp="30slbp965ncro">
        {t.issues.title}
      </motion.h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-115" data-mp="2mx0uci62r2md">
        {issues.map((issue, index) => {
        const cardInner = <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow h-full" data-id="element-116" data-mp="1bfhtgwfyvbqz">
              {/* PDF Cover */}
              <div className="h-56 md:h-80 flex items-center justify-center relative overflow-hidden" style={{
            backgroundColor: issue.coverColor
          }} data-id="element-117" data-mp="1cutyqn9ta7xf">
                {issue.coverImage ? <img src={issue.coverImage} alt={`${isHebrew ? issue.titleHe : issue.title} cover`} className="w-full h-full object-cover" loading="lazy" data-id="element-118" data-mp="18trz45bzftux" /> : <>
                    <div className="absolute inset-0 bg-gradient-to-br from-black/5 to-black/20" data-id="element-119" data-mp="l7bq70fz6mk8" />
                    <div className="relative text-center z-10" data-id="element-120" data-mp="p7vmk1sq5m5b">
                      <FileTextIcon size={64} className="mx-auto mb-4 text-white/80" data-id="element-121" data-mp="b71fbmhexr88" />
                      <h3 className="text-2xl font-bold text-white drop-shadow-lg" data-id="element-122" data-mp="g8qn8t9c9os3">
                        Issue
                      </h3>
                      <p className="text-white/90 mt-2 font-medium" data-id="element-123" data-mp="3nrp0i9n969mi">
                        {isHebrew ? issue.dateHe : issue.date}
                      </p>
                    </div>
                  </>}
              </div>

              {/* Card Info */}
              <div className="p-6" data-id="element-124" data-mp="fjqcwbg6t4wk">
                <h3 className="text-xl font-semibold text-[#1B2A4A] mb-2" data-id="element-125" data-mp="fiyk18dz5l9z">
                  {isHebrew ? issue.titleHe : issue.title}
                </h3>
                {issue.pdfUrl ? <span className="text-sm text-[#1B2A4A] group-hover:text-amber-600 transition-colors font-medium" data-id="element-126" data-mp="p9t3y63r08s9">
                    צפו ב-PDF ←
                  </span> : <span className="text-sm text-gray-400 font-medium" data-id="element-127" data-mp="y9puyedm1jqh">
                    Coming soon
                  </span>}
              </div>
            </div>;
        return <motion.div key={issue.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          transition: {
            duration: 0.2
          }
        }} className="group cursor-pointer" data-id="element-128" data-mp="2nqbqopgsbye3" data-mpi={index}>
              {issue.pdfUrl ? <a href={issue.pdfUrl} target="_blank" rel="noopener noreferrer" className="block h-full" aria-label={`${isHebrew ? issue.titleHe : issue.title} - ${t.issues.viewPdf}`} data-id="element-129" data-mp="2eqooi1g8eojz">
                  {cardInner}
                </a> : cardInner}
            </motion.div>;
      })}
      </div>
    </div>;
}